import CountUp from "react-countup";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const values = [
  { value: 100, suffix: "%" },
  { value: 24, suffix: "/24 7/7" },
  { value: 5, suffix: "+" },
  { value: 1, suffix: "" },
];

export const Stats = () => {
  const { t } = useLang();
  return (
    <section className="bg-black text-white" data-testid="stats-section">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {values.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className={`px-4 md:px-8 py-8 ${
                i % 2 !== 0 ? "border-l border-white/20" : ""
              } ${i >= 2 ? "border-t border-white/20 lg:border-t-0" : ""} ${
                i !== 0 && i % 4 !== 0 ? "lg:border-l" : ""
              }`}
            >
              <div className="font-display font-black text-6xl md:text-7xl lg:text-8xl tracking-tighter leading-none">
                <CountUp end={s.value} duration={2.4} enableScrollSpy scrollSpyOnce />
                <span>{s.suffix}</span>
              </div>
              <div className="mt-4 text-xs uppercase tracking-[0.2em] font-bold text-white/60">
                {t.stats[i]}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
